import React, { useEffect } from 'react';
import Toast from './Toast';
import { useToast } from './ToastContext';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();


  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onDismiss={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

export default ToastContainer;